import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, tap, withLatestFrom, switchMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

import * as fromNotification from './notification.reducer';
import * as NotificationActions from './notification.actions';
import * as NotificationSelectors from './notification.selectors';
import { AppState } from '../app.states';
import { APIService } from '../../services/api/api-service';
import { Router } from '@angular/router';
import * as OrdersActions from '../orders/orders.actions';

@Injectable()
export class NotificationEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly store: Store<AppState>,
    private readonly api: APIService,
    private readonly router: Router
  ) {}

  loadNotifications$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NotificationActions.loadNotifications),
      switchMap(action =>
        this.api
          .getNotifications(action.notificationType, action.query)
          .pipe(
            map(notifications =>
              NotificationActions.loadNotificationsSuccess({ notifications })
            ),
            catchError(error => {
              console.error('Error', error);
              return of(NotificationActions.loadNotificationsFailure({ error }));
            })
          )
      )
    )
  );

  addNotification$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NotificationActions.addNotification),
      // withLatestFrom(this.store.select(NotificationSelectors.getMaxId)),
      map((action, maxId) => {
        return NotificationActions.addNotificationSuccess({
          notification: { ...action.notification }
        });
      }),
      catchError(error => {
        console.error('Error', error);
        return of(NotificationActions.addNotificationFailure({ error }));
      })
    )
  );

  deleteNotification$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NotificationActions.deleteNotification),
      map(action => {
        return NotificationActions.deleteNotificationSuccess({
          id: action.id
        });
      }),
      catchError(error => {
        console.error('Error', error);
        return of(NotificationActions.deleteNotificationFailure({ error }));
      })
    )
  );

  onAction$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(NotificationActions.onAction),
        tap(({ actionType, payload }) => {
          if (actionType === 'start-consult') {
            this.router.navigate(['consultation', 'start'], {
              queryParams: {
                orderId: payload?.orderId,
                types: payload?.requiredForms?.join(','),
                customerId: payload?.customerId,
                redirectUri: payload?.redirectUri,
                verificationReqs: payload?.verificationReqs
              }
            });
          } else if (actionType === 'open-pay-modal') {
            this.store.dispatch(
              OrdersActions.openOrderPayModal({
                order: payload?.order
              })
            );
          } else if (actionType === 'start-verification') {
            this.router.navigate(['verification', 'start'], {
              queryParams: {
                orderId: payload?.orderId,
                customerId: payload?.customerId,
                redirectUri: payload?.redirectUri
              }
            });
          }
        })
      ),
    {
      dispatch: false
    }
  );
}
